export default {
  title: 'กระทบยอดธนาคาร',
  description: 'จับคู่รายการในสเตทเมนต์ธนาคารกับการชำระเงิน',
  previous_month: 'เดือนก่อนหน้า',
  next_month: 'เดือนถัดไป',

  tie_out: {
    title: 'เทียบยอดสเตทเมนต์ล่าสุด',
    account_number: 'บัญชี {{number}}',
    account_unknown: 'ไม่พบเลขที่บัญชี',
    as_of: 'ณ วันที่ {{date}}',
    scope: 'ใช้สเตทเมนต์ที่นำเข้าและมีวันที่สิ้นสุดล่าสุด โดยไม่ขึ้นกับเดือนที่เลือก ยอดบัญชี 1120 รวมทุกบัญชีธนาคารในบัญชี FlowRent นี้ ส่วนยอดสเตทเมนต์เป็นของบัญชีธนาคารที่แสดงด้านบน',
    ledger_balance: 'ยอดตามบัญชี (1120)',
    statement_balance: 'ยอดปิดตามสเตทเมนต์',
    difference: 'ผลต่าง (บัญชี − สเตทเมนต์)',
    matched: 'ยอดตรงกัน',
    different: 'ยอดไม่ตรงกัน',
    ledger_unavailable: 'ไม่พบยอดตามบัญชี จึงยังยืนยันว่ายอดตรงกันไม่ได้',
    opening_missing: 'ยังไม่ได้ตั้งยอดยกมา',
    set_opening: 'ตั้งยอดยกมา',
    opening_after_statement: 'ยอดยกมาลงวันที่ {{date}} ซึ่งอยู่หลังวันที่สเตทเมนต์ จึงยังไม่รวมอยู่ในยอดตามบัญชีที่แสดง โปรดตรวจสอบการเปรียบเทียบนี้',
  },

  statements: {
    title: 'สเตทเมนต์ธนาคาร',
    description: 'อัปโหลดและจัดการสเตทเมนต์ธนาคารสำหรับกระทบยอด',
    new: 'อัปโหลดสเตทเมนต์',
    detail: 'รายละเอียดสเตทเมนต์',
  },

  reconciliation: {
    title: 'กระทบยอด',
    tabs: {
      matched: 'จับคู่แล้ว',
      unmatched: 'ยังไม่จับคู่',
      needs_review: 'ต้องตรวจสอบ',
      ignored: 'ข้ามไป',
    },
  },

  labels: {
    slip: 'สลิป',
    view_slip: 'ดูสลิปการชำระเงิน',
    customer: 'ลูกค้า',
    invoice: 'ใบแจ้งหนี้',
    view_payment: 'ดูการชำระเงิน',
    billing_period: 'รอบบิล',
    bank_name: 'ธนาคาร',
    start_date: 'วันที่เริ่มต้น',
    end_date: 'วันที่สิ้นสุด',
    period: 'รอบสเตทเมนต์',
    file: 'ไฟล์สเตทเมนต์',
    file_hint: 'รองรับ: KBank CSV, SCB และ BBL CSV หรือ PDF',
    password: 'รหัสผ่านสเตทเมนต์ (ถ้ามี)',
    password_placeholder: 'ใส่รหัสผ่านเพื่อถอดรหัส',
    row_count: 'รายการทั้งหมด',
    matched_count: 'จับคู่แล้ว',
    unmatched_count: 'ยังไม่จับคู่',
    match_rate: 'อัตราการจับคู่',
    uploaded_by: 'อัปโหลดโดย',
    transaction_date: 'วันที่ทำรายการ',
    amount: 'จำนวนเงิน',
    reference: 'อ้างอิง',
    description: 'รายละเอียด',
    match_status: 'สถานะการจับคู่',
    matched_payment: 'การชำระเงินที่จับคู่',
    payment_method: 'วิธีชำระเงิน',
    paid_at: 'ชำระเมื่อ',
    trans_ref: 'เลขที่อ้างอิงโอน',
    select_month: 'เลือกเดือน/ปี',
    direction_credit: 'รับเข้า',
    direction_debit: 'จ่ายออก',
    net_cash_amount: 'ยอดสุทธิ',
    expense: 'ค่าใช้จ่าย',
    expense_date: 'วันที่ค่าใช้จ่าย',
    debit_match_rate: 'อัตราจับคู่รายจ่าย',
    overlap_warning_title: 'ช่วงเวลาสเตทเมนต์ทับซ้อน',
  },

  banks: {
    scb: 'SCB',
    kbank: 'กสิกรไทย',
    bbl: 'กรุงเทพ',
  },

  match_status: {
    unmatched: 'ยังไม่จับคู่',
    auto_matched: 'จับคู่อัตโนมัติ',
    manual_matched: 'จับคู่ด้วยตนเอง',
    needs_review: 'ต้องตรวจสอบ',
    matched_expense: 'ค่าใช้จ่ายที่จับคู่',
    // T131-016: สถานะสุดท้ายที่ผู้ใช้งานเลือกข้ามไป — จะไม่ถูกเสนอให้จับคู่อีก
    ignored: 'ข้ามไป',
  },

  actions: {
    create_expense: 'สร้างค่าใช้จ่าย',
    upload: 'อัปโหลดสเตทเมนต์',
    match: 'จับคู่',
    unmatch: 'ยกเลิกการจับคู่',
    review: 'ตรวจสอบ',
    search_payments: 'ค้นหาการชำระเงิน',
    search_expenses: 'ค้นหาค่าใช้จ่าย',
    select_payment: 'เลือก',
    select_expense: 'เลือก',
    confirm_unmatch: 'ยืนยันการยกเลิกจับคู่',
    // T131-012: คู่กับ create_expense สำหรับฝั่งรายรับ
    record_payment: 'บันทึกการชำระเงิน',
    // T131-016
    ignore: 'ข้ามไป',
    unignore: 'เลิกข้าม',
    confirm_ignore: 'ยืนยันการข้ามรายการ',
  },

  // EP-54: Thai has no plural inflection; single base key.
  candidates_count: '{{count}} รายการที่อาจตรงกัน',
  // T131-014: กรณีมีผู้สมัครเพียงรายเดียวและชื่อไม่ตรงกัน — ต้องแยกจากข้อความ
  // "หลายรายการ" เพื่อให้ผู้ใช้งานเข้าใจว่าเป็นรายการที่ต้องยืนยัน ไม่ใช่ความล้มเหลว
  candidates_count_single_mismatch: 'มีรายการที่อาจตรงกัน 1 รายการ แต่ชื่อไม่ตรงกัน — โปรดยืนยันก่อนเลือก',

  // T131-009/T131-014: ป้ายกำกับแถวรายการที่อาจตรงกัน
  badges: {
    name_match: 'ชื่อตรงกัน',
    name_mismatch: 'ชื่อไม่ตรงกัน',
  },

  messages: {
    // T131-006: การอัปโหลดที่ทับซ้อนกับสเตทเมนต์เดิมจะไม่ถูกปฏิเสธอีกต่อไป —
    // ระบบนำเข้าเสมอ (ตัดรายการซ้ำอัตโนมัติทีละแถว) แล้วรายงานผลให้ทราบ
    // skipped: 0 ก็ยังระบุจำนวนที่นำเข้า (ไม่ใช่ความสำเร็จแบบเงียบ); skipped > 0
    // คือผลลัพธ์ปกติของการอัปโหลดซ้ำ ไม่ใช่ความล้มเหลว
    upload_success_imported: 'นำเข้ารายการ {{count}} รายการ',
    upload_success_imported_with_skipped: 'นำเข้ารายการ {{count}} รายการ ข้าม {{skipped}} รายการที่มีอยู่แล้ว',
    overlap_warning_intro: 'การอัปโหลดนี้มีช่วงเวลาทับซ้อนกับสเตทเมนต์ที่มีอยู่แล้วของธนาคารนี้ ระบบตรวจพบรายการที่ซ้ำกันโดยอัตโนมัติและจะไม่นำเข้าซ้ำอีก',
    match_success: 'จับคู่รายการสำเร็จ',
    unmatch_success: 'ยกเลิกการจับคู่สำเร็จ',
    unmatch_confirm: 'ต้องการยกเลิกการจับคู่รายการนี้ใช่ไหม?',
    // T131-016: ดำเนินการทีละรายการโดยผู้ใช้งานเท่านั้น — ไม่มีการทำเป็นกลุ่มหรือกฎอัตโนมัติ
    ignore_confirm: 'ต้องการข้ามรายการนี้ใช่ไหม? รายการนี้จะถูกพักไว้และจะไม่ถูกเสนอให้จับคู่อีก สามารถเลิกข้ามได้ภายหลัง',
    no_statements: 'ยังไม่มีสเตทเมนต์ที่อัปโหลด',
    no_transactions: 'ไม่พบรายการ',
    no_payment_candidates: 'ไม่พบการชำระเงินที่ตรงกัน',
    error_loading: 'ไม่สามารถโหลดข้อมูลได้',
    error_description: 'กรุณาลองใหม่ภายหลัง',
    ready_for_accounting: 'รายการทั้งหมดจับคู่แล้ว เดือนนี้พร้อมสำหรับการบัญชี',
  },

  errors: {
    wrong_password: 'รหัสผ่านไม่ถูกต้องหรือไฟล์ถูกเข้ารหัส กรุณาตรวจสอบแล้วลองใหม่',
    unsupported_format: 'ธนาคารนี้ไม่รองรับไฟล์ PDF กรุณาใช้ CSV',
    empty_file: 'ไม่พบรายการในไฟล์ที่อัปโหลด',
  },

  placeholders: {
    search_amount: 'จำนวนเงิน',
    search_date: 'วันที่',
    search_date_from: 'จากวันที่',
    search_date_to: 'ถึงวันที่',
    search_reference: 'อ้างอิง',
  },

  filters: {
    search: 'ค้นหาการชำระเงิน...',
  },

  empty: {
    no_expense_candidates: 'ไม่พบค่าใช้จ่ายที่มียอดตรงกัน หากยังไม่ได้บันทึก สามารถสร้างได้เลย',
    // T131-012: คู่กับ no_expense_candidates สำหรับฝั่งรายรับ
    no_payment_candidates: 'ยังไม่พบการชำระเงินที่ตรงกัน หากยังไม่ได้บันทึก สามารถบันทึกได้เลย',
    statements: 'ยังไม่มีสเตทเมนต์ที่อัปโหลด',
    transactions: 'ไม่มีรายการในหมวดนี้',
    payment_search: 'ไม่พบการชำระเงินที่ตรงกัน',
  },

  summary: {
    total: 'ทั้งหมด',
    matched: 'จับคู่แล้ว',
    unmatched: 'ยังไม่จับคู่',
    needs_review: 'ต้องตรวจสอบ',
    match_rate: 'อัตราการจับคู่',
    credit_match_rate: 'อัตราจับคู่รายรับ',
    debit_match_rate: 'อัตราจับคู่รายจ่าย',
  },

  tabs: {
    transactions: 'รายการ',
    statements: 'สเตทเมนต์',
    // EP-143 T143-016: แท็บสำหรับผู้ดูแลระบบขึ้นไปเท่านั้น
    slip_recon: 'กระทบรายการสลิป',
    view: 'มุมมอง',
    all: 'ทั้งหมด',
    // EP-97: default work-queue sub-tab (unmatched + needs_review).
    needs_attention: 'ต้องดำเนินการ',
  },

  // EP-143 T143-016: Slip recon tab strings
  slip_recon: {
    empty_title: 'ไม่มีรายการตรวจสอบสลิป',
    empty_description: 'การชำระเงินที่ยืนยันแล้วแต่ไม่พบรายการรับเงินในสเตทเมนต์ธนาคารจะแสดงที่นี่',
    col_paid_at: 'ชำระเมื่อ',
    col_amount: 'จำนวนเงิน',
    col_customer: 'ลูกค้า',
    col_slip_uploaded_at: 'อัปโหลดสลิปเมื่อ',
    col_gate_summary: 'สรุปการตรวจสอบ',
    flag_fraud: 'แจ้งทุจริต',
    flag_success: 'แจ้งรายการทุจริตสำเร็จ',
    ml_outcome: {
      ref1_exact: 'เลขอ้างอิงตรงกัน',
      amount_trans_ref: 'ยอดเงิน + อ้างอิง',
      none: 'ไม่ตรงกัน',
      // EP-145 A5: the EP-143 rental outcomes. Without these the chip rendered
      // a raw key for every rental slip in this tab.
      ml_agree: 'ML เห็นตรงกัน',
      ml_disagree: 'ML ไม่เห็นตรงกัน',
      ml_solo_verify: 'ML ยืนยันฝ่ายเดียว',
      ml_pass_rdcw_fail: 'ML ผ่าน แต่ธนาคารปฏิเสธ',
    },
    orphan_section_title: 'รายการรับเงินที่ยังไม่จับคู่',
    orphan_section_description: 'รายการรับเงินในธนาคารที่ยังไม่มีการชำระเงินคู่กันสามารถดูได้ที่แท็บ "รายการ" ใต้ "ต้องดำเนินการ"',
    orphan_section_link: 'ดูรายการรับเงินที่ยังไม่จับคู่ →',
  },

  // EP-100: Stripe payout reconciliation
  stripe_payout: {
    title: 'การโอนเงิน Stripe',
    description: 'นำเข้าไฟล์กระทบยอดการโอนเงินแบบรายการจาก Stripe เพื่อจับคู่รายการฝากธนาคารและบันทึกค่าธรรมเนียมเข้าบัญชี',
    upload_label: 'ไฟล์ CSV กระทบยอดการโอนเงิน Stripe',
    upload_hint: 'อัปโหลดไฟล์ Itemized Payout Reconciliation CSV ที่ส่งออกจาก Stripe',
    upload_action: 'นำเข้าข้อมูลการโอนเงิน Stripe',
    import_result_title: 'ผลการนำเข้าการโอนเงิน',
    payout_id: 'รหัสการโอนเงิน',
    gross: 'ยอดรวม',
    fee: 'ค่าธรรมเนียมการชำระเงิน',
    net: 'ยอดสุทธิที่ฝาก',
    matched_deposit: 'รายการฝากธนาคารที่จับคู่',
    arrival_date: 'วันที่ได้รับเงิน',
    currency: 'สกุลเงิน',
    fee_posted: 'บันทึกค่าธรรมเนียมแล้ว',
    fee_not_posted: 'ยังไม่บันทึกค่าธรรมเนียม (ระบบบัญชีปิดอยู่)',
    matched: 'จับคู่แล้ว',
    unmatched: 'ยังไม่จับคู่',
    import_success_summary: 'นำเข้า {{imported}} รายการ จับคู่กับรายการธนาคารแล้ว {{matched}} รายการ',
    import_success: 'นำเข้าข้อมูลการโอนเงิน Stripe สำเร็จ',
    import_error: 'ไม่สามารถนำเข้าไฟล์ CSV การโอนเงิน Stripe ได้',
    duplicate_payout: 'การโอนเงินนี้ถูกนำเข้าแล้ว',
  },
}
